import React, { Component } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import EpisodeOld from '../EpisodeOld';
import { fetchEpisode } from '../../episodePreview';
import { clickStation } from '../../stations';

const mapStateToProps = (
  { episodePreview, stations: { stations } },
  { location }
) => ({
  ...episodePreview,
  location,
  stations,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    clickStation: index => dispatch(clickStation(index)),
    fetchEpisode: episodeId => dispatch(fetchEpisode('', episodeId)),
  },
});

class EpisodeOldContainer extends Component {
  // Static SSR data function
  static fetchData({ location, store, baseUrl, match: { params } }) {
    const query = queryString.parse(location.search);
    if (query.at) {
      return store.dispatch(fetchEpisode(baseUrl, params.episodeId, query.at));
    }
    return store.dispatch(fetchEpisode(baseUrl, params.episodeId));
  }

  // note on data fetching: This component can involve route changes (e.g. new station)
  // https://github.com/ReactTraining/react-router/blob/master/docs/guides/ComponentLifecycle.md
  componentDidMount() {
    const {
      actions: { fetchEpisode },
      location,
      match: { params },
    } = this.props;
    const query = queryString.parse(location.search);
    fetchEpisode(params.episodeId, query.at);
  }

  render() {
    return <EpisodeOld {...this.props} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EpisodeOldContainer);
